import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import './../../css/green.css'

import { startTimer, tickTimer } from './../../actions/socket'
import TeamName from './TeamName'
import theme from './../../themes/green/theme'

class Scoreboard extends Component {
  componentDidMount() {
    if (!this.props.match.timerStarted) {
      this.props.startTimer()
      this.runTime()
    }
  }

  runTime() {
    this.props.tickTimer()
    setTimeout(() => this.runTime(), 1000)
  }

  formatTime() {
    const { timer } = this.props.match
    let minutes = Math.floor(timer / 60),
      seconds = timer - 60 * minutes,
      strMinutes = '',
      strSeconds = ''
    if (minutes < 10) strMinutes = '0'
    strMinutes += minutes
    if (seconds < 10) strSeconds = '0'
    strSeconds += seconds
    return { strMinutes, strSeconds }
  }

  render() {
    const { match } = this.props
    const { strMinutes, strSeconds } = this.formatTime()
    const teamSize = Math.max(
      match.home.name && match.home.name.length,
      match.away.name && match.away.name.length
    )
    const Fouls = (
      <div className="fouls-row">
        <span
          className={
            'fouls ' +
            (match.home.fouls > 4 ? 'red-background' : 'yellow-background')
          }
        >
          {match.home.fouls}
        </span>
        <span>Fouls</span>
        <span
          className={
            'fouls ' +
            (match.away.fouls > 4 ? 'red-background' : 'blue-background')
          }
        >
          {match.away.fouls}
        </span>
      </div>
    )
    return (
      <div className="scoreboard-wrap">
        <div className="header-bar">
          <img
            src={theme.left_image.img}
            alt="Left"
            className="header-logo"
          />
          <div className="timer">
            <span>{strMinutes}</span>
            <span className="timer-colon">:</span>
            <span>{strSeconds}</span>
          </div>
          {(this.props.logoUrl || theme.left_image) && (
            <img
              src={this.props.logoUrl || theme.left_image.img}
              alt="Right"
              className="header-logo"
            />
          )}
        </div>

        <div className="score-area">
          <div className="home score">{match.home.score}</div>
          <div className="score-center">
            <div className="equals">=</div>
            {theme.fouls && Fouls}
          </div>
          <div className="away score">{match.away.score}</div>
        </div>

        <div className="team-bar">
          <div className="team-home">
            <TeamName teamSize={teamSize} name={match.home.name} />
          </div>
          <div className="separator"></div>
          <div className="team-away">
            <TeamName teamSize={teamSize} name={match.away.name} />
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  match: state.match,
  logoUrl: state.match.logo_url,
})

const mapDispatchToProps = (dispatch, ownProps) => ({
  tickTimer: () => dispatch(tickTimer()),
  startTimer: () => dispatch(startTimer()),
})

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Scoreboard)
)
